var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "19px",
    viewBox: "0 0 13 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CleverSparky-Web-App-V2.0---UI-Updates-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Support",
    transform: "translate(-21.000000, -276.000000)",
    stroke: "#666162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_phone",
    transform: "translate(21.500000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    x: 0,
    y: 0,
    width: 12,
    height: 17,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3 L12,3",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13 L12,13",
    id: "Stroke-3-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,14.9911195 C6.5,15.2671195 6.276,15.4911195 6,15.4911195 C5.724,15.4911195 5.5,15.2671195 5.5,14.9911195 C5.5,14.7151195 5.724,14.4911195 6,14.4911195 C6.276,14.4911195 6.5,14.7151195 6.5,14.9911195 Z",
    id: "Stroke-5",
    fill: "#666162"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.47a1f0f69a84194d58e11ddd2e72db3e.svg";
export { ForwardRef as ReactComponent };